import { render, staticRenderFns } from "./planIntro.vue?vue&type=template&id=056bc53d&scoped=true&"
import script from "./planIntro.vue?vue&type=script&lang=js&"
export * from "./planIntro.vue?vue&type=script&lang=js&"
import style0 from "./planIntro.vue?vue&type=style&index=0&id=056bc53d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056bc53d",
  null
  
)

export default component.exports